import Vue from 'vue'
import VueRouter from 'vue-router'
import Top from '../views/index.vue'
import VueGtag from "vue-gtag";
// import VueAnalytics from 'vue-analytics';

Vue.use(VueRouter)

let desc = "合同会社ロケモＡＩのマップサービス「ロケモシェア+」．従来のロケモシェアより画像の共有に特化し，旅行の記録やフォトコンテスト，聖地巡礼マップに最適になりました！！";
const routes = [
    {
        path: '/',
        name: 'Top',
        component: Top,
        meta: { title: 'ロケモシェア+：Top', desc: desc }
    },
    {
        path: '/term/',
        name: 'Terms',
        component: () => import('../views/term.vue'),
        meta: { title: 'ロケモシェア+：Terms', desc: desc }
    },
    {
        path: '/privacy/',
        name: 'PrivacyPolicy',
        component: () => import('../views/privacy.vue'),
        meta: { title: 'ロケモシェア+：プライバシーポリシー', desc: desc }
    },
    {
        path: '/login/',
        name: 'Login',
        component: () => import('../views/login.vue'),
        meta: { title: 'ロケモシェア+：ログイン', desc: desc }
    },
    {
        path: '/map/',
        name: 'Map',
        component: () => import('../views/map.vue'),
        meta: { title: 'ロケモシェア+：マップ', desc: desc }
    },
    {
        path: '/admin/',
        name: 'Admin',
        component: () => import('../views/admin.vue'),
        meta: { title: 'ロケモシェア+：管理者', desc: desc }
    },
    {
        path: '/user/',
        name: 'User',
        component: () => import('../views/user.vue'),
        meta: { title: 'ロケモシェア+：ユーザ', desc: desc }
    },
]

const index = new VueRouter({
    mode: 'history',
    routes: routes,
    base: process.env.BASE_URL
})

Vue.use(VueGtag, {
    config: {id: "G-1HFEVJJCJX"}
}, index);
// Vue.use(VueAnalytics, {//G-JF85GMGX46 新規
//     id: "G-1HFEVJJCJX",//'G-QQ783EBX01',//FB
//     index,
// });

export default index
